import { useState } from "react";
import type {
  RowDensityConfig,
  RowDensityValue,
  TableRowDensity,
} from "../types";

type Props = {
  rowDensity?: false | RowDensityValue | TableRowDensity;
};

export function useRowController({
  rowDensity: initialRowDensity,
}: Props): RowDensityConfig {
  const isControlled =
    initialRowDensity &&
    typeof initialRowDensity === "object" &&
    "value" in initialRowDensity;

  const controlledRowDensity = isControlled ? initialRowDensity : undefined;

  const [internalRowDensity, setInternalRowDensity] = useState<RowDensityValue>(
    isControlled
      ? controlledRowDensity!.value
      : typeof initialRowDensity === "string"
        ? initialRowDensity
        : "default",
  );

  const rowDensity = isControlled
    ? controlledRowDensity!.value
    : internalRowDensity;

  const setRowDensity = (value: RowDensityValue) => {
    if (isControlled) {
      controlledRowDensity!.onChange(value);
    } else {
      setInternalRowDensity(value);
    }
  };

  const showRowDensityControl = initialRowDensity !== false;

  return {
    value: rowDensity,
    onChange: setRowDensity,
    show: showRowDensityControl,
  };
}
